import Box from "../../Components/Box";
import React, { useEffect, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import Carousel from "../../Components/carousel/Carousel";
import CategorySectionCreator from "../../Components/CategorySectionCreator";
import ProductCard1 from "../../Components/product-cards/ProductCard1";
import StyledRelatedProducts from "./RelatedProductCarouselStyle";
import { useAppContext } from "../../contexts/app/AppContext";
import Typography from "../../Components/Typography";
import { Link } from '@inertiajs/react'
export interface RelatedProductsCarousel {
    items?: Array;
    screenWidth?: Number;
}

const RelatedProductsCarousel: React.memo = ({
    items,
    screenWidth
}) => {

    const { fixPrice } = useAppContext()


    return (
        <>
            {!!items && !!items.length &&
                <StyledRelatedProducts>
                    <Typography className='block-title'>
                        Σχετικά Προϊόντα
                    </Typography>

                    <Box mb="-0.25rem" className="inner-new-prod">
                        <Carousel
                            totalSlides={items.length}
                            showArrow={false}
                            visibleSlides={screenWidth > 768 ? 4 : 2}
                            spacing={'5px'}
                            infinite={false}
                        >
                            {items.map((item) => (

                                
                                <Box py="0.25rem" key={item.id}>
                                    {/*price={product?.is_package === 1 || product?.show_total_price === 0 ? product?.product_price_discount : product?.price}*/}

                                    <Link href={item.url_key}>
                                    <ProductCard1
                                        id={item.id}
                                        sku={item.sku}
                                      
                                        imgUrl={item.base_image['medium_image_url']}
                                        title={item.name}
                                        rating={4}
                                        //price={parseFloat(item.formatted_price.replace(/[^0-9.-]+/g,""))}
                                        price={item.show_total_price ? fixPrice(parseFloat(item.price)) : fixPrice(parseFloat(item?.product_price_discount))}
                                        off={item.off}
                                        key={item.id}
                                        variants={item.variants ?? []}
                                        attributes={item.attributes}
                                        className='newarrival'
                                        initialPrice={item.is_package || !item.show_total_price ? fixPrice(parseFloat(item.product_price)) : fixPrice(parseFloat(item.initialPrice))}

                                    /></Link>
                                </Box>
                            ))}
                        </Carousel>
                    </Box>
                </StyledRelatedProducts >
            }
        </>
    )
}

export default RelatedProductsCarousel
